import { UI_CONSTANTS } from "../../../../Constants/constants";
import { ProductValueType } from "../../../../Types/Product/ProductValueType";

export const packSizeToDisplay = (values: ProductValueType) => {
    if (values.alias === UI_CONSTANTS.SAINSBURYS_SKU || values.alias === UI_CONSTANTS.SAINSBURYS_PACK) {
      return `CS${values.packSize}`;
    }

    if (values.alias === UI_CONSTANTS.ARGOS) {
      return (values.packSize == 1) ? `EA` : `CS${values.packSize}`;
    }

    return values.packSize; 
  }